import { makeStyles } from "tss-react/mui";
const useDatePickerFooterSingleModeClasses = makeStyles()(() => {
  return {
    datePickerFooterSingleModeInput: {
      marginBottom: 0
    }
  };
});
export {
  useDatePickerFooterSingleModeClasses
};
//# sourceMappingURL=DatePickerFooterSingleMode.style.js.map
